var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.225 6.75h-4.45c.116-.57.62-1 1.225-1h2c.605 0 1.11.43 1.225 1m4.775 0h-3.261A2.75 2.75 0 0 0 13 4.25h-2a2.75 2.75 0 0 0-2.739 2.5H5a.75.75 0 0 0 0 1.5h1.271l.803 8.024A2.75 2.75 0 0 0 9.81 18.75h4.38a2.75 2.75 0 0 0 2.736-2.476l.803-8.024H19a.75.75 0 0 0 0-1.5m-2.779 1.5H7.78l.787 7.874A1.25 1.25 0 0 0 9.81 17.25h4.38a1.25 1.25 0 0 0 1.244-1.126zM10.5 9.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m3 0a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgDelete;